import React from "react";
import defaultBanner from "assets/teamphotobannercopy.webp";
import "./PageHero.css";

const PageHero = ({ title, subtitle, imageSrc = defaultBanner, imageAlt }) => (
  <section className="page-hero" aria-labelledby="page-hero-title">
    <img
      className="page-hero__image"
      src={imageSrc}
      alt={imageAlt || ""}
      width="1920"
      height="400"
    />
    <div className="page-hero__overlay" aria-hidden="true" />
    <div className="page-hero__content">
      <h1 id="page-hero-title" className="page-hero__title">
        {title}
      </h1>
      {subtitle && <p className="page-hero__subtitle">{subtitle}</p>}
    </div>
  </section>
);

export default PageHero;
